import React, { useEffect, useState, useRef } from "react";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";
import { getSearchDocument, getRecent } from "../../store/actions";

import { calculatePeriod, calculateDateRange, PERIOD_OPTIONS } from "../../helpers/dateUtils";
import NavDocPlace from "./components/nav/nav";
import FileDocPlace from "./components/files/files";
import { toast, ToastContainer } from "react-toastify";
import ReadOnlyBanner from "../Components/ReadOnlyBanner";
import { isReadOnlyCached } from "../../helpers/legacyReadOnly";
import Chip from "@mui/material/Chip";

//API CALL
import { getUserList } from "../../store/user/actions";
import { getDocTypeList1 } from "../../store/docType/actions";
import { getTreeList } from "../../store/tree/actions";
import { postDeleteDoc, postEmptyTrashBin } from "../../store/explorer/actions";
import {
  getDetailFolderList,
} from "../../store/document/actions";
//END
import "./explorer-style.scss";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../components/title/title";
import SelectDropdown from "../../components/form/selectDropdown";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import Button from "@mui/material/Button";
import UploadIcon from "@mui/icons-material/Upload";
import { useStyles } from "./style";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Dropzone from "react-dropzone";
import {
  uploadFileManual,
  validateFiles,
} from "../../services/FileUploadService";
import { getCanonicalPath } from "../../services/ocr";
import Swal from "sweetalert2";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import documentIcon from "../../assets/document.svg";
import Grid from "@mui/material/Grid";
import NewFilterDocPlace from "./components/filter/filter";
import AllFilesDocPlace from "./components/displayFiles/file";
import sseService from "../../services/sseService";

var filterSearch;
var bySearch = false;

/** Max concurrent single-file upload requests (API accepts one file per call). */
const UPLOAD_CONCURRENCY = 3;

const ExplorerDocPlace = (props) => {
  let params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const notify = (msj, event) => toast[event](msj);
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [startPage] = useState(true);
  const [mapPath, setMapPath] = useState([]);
  const [showTree, setShowTree] = useState(true);
  const [loading7, setLoading7] = useState(false);
  const [archiveId, setArchiveId] = useState("");
  const [showUploadUI, setShowUploadUI] = useState(false);
  const uploadInputRef = useRef(null);
  const scrollableContainerRef = useRef(null);
  /** Remaining files that need Replace / Keep both after validate (FIFO). */
  const pendingDuplicateFilesRef = useRef([]);
  const [uploadStatusByKey, setUploadStatusByKey] = useState({});

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [tree, setTree] = useState({
    label: "",
    value: "",
    parent: "",
  });
  const [showRecent, setShowRecent] = useState(true);
  const [nextPage, setNextPage] = useState([]);
  const [doctypes, setDoctypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [parentArchiveId, setParentArchiveId] = useState("");
  const [detailFolder, setDetailFolder] = useState([]);
  const [totalFiles, setTotalFiles] = React.useState([]);
  const [closeUploadFiles, setCloseUploadFiles] = React.useState(false);
  const [upDocType, setUpDocType] = React.useState({});
  const [listUpDocType, setListUpDocType] = React.useState([]);
  const [loading8, setLoading8] = React.useState(false);
  const [item, setItem] = React.useState(null);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [showOptionMenuItems, setShowOptionMenuItems] = React.useState(false);
  const [isTrash, setIsTrash] = React.useState(false);
  const [messageText, setMessageText] = React.useState("Getting Explorer Data");
  const [resetPager, setResetPager] = React.useState(false);
  const [documentName, setDocumentName] = React.useState("");

  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [targetFileId, setTargetFileId] = useState(null); // ID del archivo que estamos buscando
  const [forwardStack, setForwardStack] = useState([]); // For Back/Forward navigation

  const [uploaded, setUploaded] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const handleClose = () => {
    setOpenModal(false);
    pendingDuplicateFilesRef.current = [];
    setFilesToUpload([]);
  };
  const [searchActive, setSearchActive] = useState(false);
  const [searchCurrentQuery, setSearchCurrentQuery] = useState("");
  const [recentFiles, setRecentFiles] = useState([]);
  const [limit, setLimit] = useState(0);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [showAllFilesFromRecent, setShowAllFilesFromRecent] = useState(false);
  const [daysFilter, setDaysFilter] = useState(PERIOD_OPTIONS[0].days); // Default: DAY (1 day)
  const [autoCompleteResults, setAutoCompleteResults] = useState([]);
  const [allFilesUnfiltered, setAllFilesUnfiltered] = useState([]);

  const [inFolderView, setInFolderView] = useState(false);

  const [valueSearch, setValueSearch] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  // Track last processed search query to avoid duplicate API calls
  const lastProcessedQueryRef = useRef("");
  const [filterList, setFilterList] = useState({
    filters: [],
    fullTextSearch: {
      text: "",
      fields: [],
    },
    fromDate: "",
    toDate: "",
    daysAgo: 0,
    minsAgo: 0,
  });
  let filterListC = {
    filters: [],
    fullTextSearch: {
      text: "",
      fields: [],
    },
    fromDate: "",
    toDate: "",
    daysAgo: 0,
    minsAgo: 0,
  };

  const handleScrollContainerToTop = () => {
    if (scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (valueSearch && valueSearch.trim() !== "") {
        const { fromDate, toDate } = calculateDateRange(daysFilter);
        const obj = {
          filters: [],
          fullTextSearch: {
            text: valueSearch.toLowerCase(),
            fields: [],
          },
          daysAgo: 0,
          minsAgo: 0,
          fromDate,
          toDate,
        };

        dispatch(
          getSearchDocument(
            {
              page: 1,
              pageSize: 5, // limit results for autocomplete
              period: calculatePeriod(daysFilter), // Use 30-day default period
              data: obj,
            },
            navigate
          )
        );
      } else {
        setAutoCompleteResults([]);
      }
    }, 500); // debounce

    return () => clearTimeout(delayDebounceFn);
  }, [valueSearch, daysFilter]);

  useEffect(() => {
    const searchQuery = searchParams.get("q");
    if (searchQuery && searchQuery.trim() !== "") {
      // Only trigger search if query changed to avoid duplicate calls
      if (lastProcessedQueryRef.current !== searchQuery) {
        lastProcessedQueryRef.current = searchQuery;
        setValueSearch(searchQuery);
        setSearchCurrentQuery(searchQuery);
        setSearchActive(true);
        handleSearchClick(searchQuery);
      }
    }
    localStorage.setItem("navigation", "/explorer");
    setTimeout(() => {
      if (localStorage.getItem("mapPath") && params.id) {
        let mp = JSON.parse(localStorage.getItem("mapPath"));
        if (mp.length > 0) {
          setMapPath(mp);
          let idFolder = mp[mp.length - 1].id;
          clickMap(idFolder);
        }
      }
    }, 1000);
  }, [searchParams]);

  const resetSearch = () => {
    setSearchParams({});
    setValueSearch("");
    setSearchCurrentQuery("");
    setSearchActive(false);
    setAutoCompleteResults([]);
  };
  const handleSearchClick = (query = valueSearch) => {
    if (query) {
      setSearchActive(true);
      setSearchCurrentQuery(query);
      // Update URL with search query
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set("q", query);
        return newParams;
      });
      const { fromDate, toDate } = calculateDateRange(daysFilter);
      const obj = {
        filters: [],
        fullTextSearch: {
          text: String(query).toLowerCase(),
          fields: [],
        },
        daysAgo: 0,
        minsAgo: 0,
        fromDate,
        toDate,
      };

      dispatch(
        getSearchDocument(
          {
            page: 1,
            pageSize: pageSize,
            period: calculatePeriod(daysFilter), // Use 30-day default period
            data: obj,
          },
          navigate
        )
      );
    } else {
      toast.error("Enter a value");
    }
  };

  const handleSelectFile = (file) => {
    if (file.fkArchive?.type === "Folder") {
      const item = {
        label: file.fkArchive.name,
        value: file.fkArchive.id,
        parent: file.fkArchive.parentArchiveId,
      };
      clickTree(item);
    } else {
      openFile(file);
    }
    setValueSearch("");
  };

  const { responseUser, errorUser, loading } = useSelector((state) => ({
    responseUser: state.User.responseUser,
    errorUser: state.User.errorUser,
    loading: state.User.loadingUser,
  }));
  const { responseDocType1, errorDocType1, loading2 } = useSelector(
    (state) => ({
      responseDocType1: state.DocType.responseDocType1,
      errorDocType1: state.DocType.errorDocType1,
      loading2: state.DocType.loadingDocType1,
    })
  );

  const { responseTree, errorTree, loading3 } = useSelector((state) => ({
    responseTree: state.Tree.responseTree,
    errorTree: state.Tree.errorTree,
    loading3: state.Tree.loadingTree,
  }));
  const { responseDetailFolder, errorDetailFolder, loading4 } = useSelector(
    (state) => ({
      responseDetailFolder: state.DetailFolder.responseDetailFolder,
      errorDetailFolder: state.DetailFolder.errorDetailFolder,
      loading4: state.DetailFolder.loadingDetailFolder,
    })
  );

  const { responseSearchArchives, errorSearchArchives, loading5 } = useSelector(
    (state) => ({
      responseSearchArchives: state.DetailFolder.responseSearchArchives,
      errorSearchArchives: state.DetailFolder.errorSearchArchives,
      loading5: state.DetailFolder.loadingSearchArchives,
    })
  );
  const { responseDeleteDoc, errorDeleteDoc, loading6 } = useSelector(
    (state) => ({
      responseDeleteDoc: state.Explorer.responseDeleteDoc,
      errorDeleteDoc: state.Explorer.errorDeleteDoc,
      loading6: state.Explorer.loadingDeleteDoc,
    })
  );
  const { responseSearchDocument, loadingSearchDocument, errorSearchDocument } = useSelector(
    (state) => ({
      responseSearchDocument: state.Search.responseSearchDocument,
      loadingSearchDocument: state.Search.loadingSearchDocument,
      errorSearchDocument: state.Search.errorSearchDocument,
    })
  );
  const { responseRecent, loadingRecent, errorRecent } = useSelector((state) => ({
    responseRecent: state.Search.responseRecent,
    loadingRecent: state.Search.loadingRecent,
    errorRecent: state.Search.errorRecent,
  }));

  const refreshRecentFiles = () => {
    if (!showRecent) return;

    const { fromDate, toDate } = calculateDateRange(daysFilter);
    dispatch(
      getRecent(
        {
          page: 1,
          pageSize: 25, // limit results for recent files
          period: calculatePeriod(daysFilter),
          data: {
            filters: [],
            fullTextSearch: { text: ".", fields: [] },
            daysAgo: 0,
            minsAgo: 0,
            fromDate,
            toDate,
          },
        },
        navigate
      )
    );
  };

  const handleViewAll = () => {
    setSearchActive(true);
    handleSearchClick(valueSearch);
  };

  /**DOC-1441  call to EmptytrashBin endpoint*/
  const { responseEmptyTrash, errorEmptyTrash, loadingEmptyTrash } =
    useSelector((state) => ({
      responseEmptyTrash: state.Explorer.responseEmptyTrash,
      errorEmptyTrash: state.Explorer.errorEmptyTrash,
      loadingEmptyTrash: state.Explorer.loadingEmptyTrash,
    }));

  useEffect(() => {
    if (responseEmptyTrash) {
      console.log("EMPTY TRASH", responseEmptyTrash);
      setPage(1);
      setResetPager(true);
      refresh("", page, pageSize);
      refreshRecentFiles();
    }
  }, [responseEmptyTrash]);
  //

  /* OLD STUFF useEffect(() => {
  /*useEffect(() => {
    if (params.id) {
      setLoading8(true);
      setTimeout(() => {
        console.log("params.id-------->", params.id);
        setLoading8(false);
        setArchiveId(params.id);
        getCanonicalPathFn(params.id);
      }, 1000);
    }
  }, []); */
  useEffect(() => {
    // Only call getCanonicalPath if params.id is present AND archiveId is not already set
    // This prevents duplicate API calls on component mount
    if (params.id && !archiveId) {
      // Check if there's a search query in URL - if so, don't clear search state
      const searchQuery = searchParams.get("q");
      const hasSearchQuery = searchQuery && searchQuery.trim() !== "";
      
      // Clear previous state when navigating to a new ID (unless we have a search query)
      setMapPath([]);
      setInFolderView(true); // Force folder view to show AllFilesDocPlace instead of FileDocPlace
      
      // Only clear search state if there's no search query in URL
      if (!hasSearchQuery) {
        setSearchActive(false);
        setValueSearch("");
      }
      
      setTargetFileId(params.id); // Establecer el archivo que estamos buscando

      setLoading8(true);
      setTimeout(() => {
        setLoading8(false);
        setArchiveId(params.id);
        getCanonicalPathFn(params.id);

        const route_item = JSON.parse(localStorage.getItem("route-item"));
        const route_mapPath = JSON.parse(localStorage.getItem("route-mapPath"));

        if (route_mapPath) {
          setMapPath(route_mapPath);

          // clickTree(route_item,route_mapPath);

          if (route_mapPath.length > 0)
            clickMap(route_mapPath[route_mapPath.length - 1].id, route_mapPath);
        }
      }, 1000);
    } else {
      localStorage.removeItem("route-item");
      localStorage.removeItem("route-mapPath");
      setTargetFileId(null); // Clear target file when no specific ID
    }
  }, [params.id]);

  useEffect(() => {
  }, [mapPath]);

  useEffect(() => {
    if (responseDocType1 && responseDocType1.data) {
      let v = [];
      responseDocType1.data.map((item) => {
        v.push({
          label: item.name,
          value: item.id,
        });
      });
      setListUpDocType(v);
    }
  }, [responseDocType1]);

  useEffect(() => {
    if (responseDeleteDoc !== null) {
      // Add delay to allow cache invalidation to propagate before refresh
      // This prevents dirty reads when the delete operation has completed
      // but the cache hasn't been invalidated yet on all nodes
      const refreshTimer = setTimeout(() => {
        dispatch(
          getDetailFolderList(
            {
              parentArchiveId:
                mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
              page: page,
              pageSize: pageSize,
              cacheBust: Date.now(), // Force fresh data fetch
            },
            navigate
          )
        );
        dispatch(
          getTreeList(
            {
              parentArchiveId:
                mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
              direction: "",
              cacheBust: Date.now(), // Force fresh data fetch
            },
            navigate
          )
        );
        refreshRecentFiles();
      }, 500); // 500ms delay for cache invalidation propagation

      return () => clearTimeout(refreshTimer);
    }
  }, [responseDeleteDoc]);
  useEffect(() => {
    // Always load user list and doc types regardless of params.id
    // Only fetch users if we don't already have data (avoids duplicate SystemUser/All calls)
    if (!responseUser?.data) {
      dispatch(getUserList({}, navigate));
    }
    dispatch(
      getDocTypeList1(
        {
          page: page,
          pageSize: pageSize,
          sortBy: "name",
          sortOrder: 1,
          filtered: false,
        },
        navigate
      )
    );
    
    // Only load tree and folder list if no params.id (root explorer)
    if (!params.id) {
      dispatch(
        getTreeList(
          { parentArchiveId: parentArchiveId, direction: "" },
          navigate
        )
      );
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId: "",
            page: 1,
            pageSize: pageSize,
          },
          navigate
        )
      );
    }

    const _recentFiles = localStorage.getItem("recentFiles");
    setViewMode(
      localStorage.getItem("viewMode")
        ? localStorage.getItem("viewMode")
        : "grid"
    );
    if (_recentFiles) {
      setShowRecent(_recentFiles === "true");
    } else {
      setShowRecent(true);
    }
  }, [startPage]);

  // SSE connection for real-time cache invalidation notifications
  useEffect(() => {
    const token = localStorage.getItem("authUser");
    const customerId = localStorage.getItem("customerId");
    const apiBaseUrl = process.env.REACT_APP_HOST_API;

    if (token && customerId && apiBaseUrl) {
      // Connect to SSE endpoint
      sseService.connect(apiBaseUrl, token, customerId);

      // Subscribe to cache invalidation events
      const unsubscribe = sseService.subscribe('cache-invalidation', (event) => {
        // Get current folder ID
        const currentFolderId = mapPath.length > 0 ? mapPath[mapPath.length - 1].id : 'root';

        // Check if this event affects the current view
        const shouldRefresh =
          event.parentId === currentFolderId ||
          event.affectedId === currentFolderId ||
          event.sourceParentId === currentFolderId ||
          event.destParentId === currentFolderId ||
          currentFolderId === 'root'; // Always refresh root view

        if (shouldRefresh) {
          toast.info('Content updated');

          // Refresh with cache bust
          dispatch(
            getDetailFolderList(
              {
                parentArchiveId: mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
                page: page,
                pageSize: pageSize,
                cacheBust: Date.now(),
              },
              navigate
            )
          );
          dispatch(
            getTreeList(
              {
                parentArchiveId: mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
                direction: "",
                cacheBust: Date.now(),
              },
              navigate
            )
          );
        }
      });

      // Cleanup on unmount
      return () => {
        unsubscribe();
        sseService.disconnect();
      };
    }
  }, [mapPath, page, pageSize]); // Re-subscribe when folder changes

  const showRecentFiles = () => {
    localStorage.setItem("recentFiles", !showRecent);
    setShowRecent(!showRecent);
  };

  const showViewMode = (value) => {
    localStorage.setItem("viewMode", value);
    setViewMode(value);
  };

  useEffect(() => {
    if (responseSearchArchives) {
      setDetailFolder(responseSearchArchives);
      //setLimit(responseSearchArchives.header?.totalRecords)
    }
  }, [responseSearchArchives]);

  useEffect(() => {
    if (responseDetailFolder) {
      setDetailFolder(responseDetailFolder);
      setLimit(responseDetailFolder.header?.totalRecords);

      if (responseDetailFolder.data) {
        setAllFilesUnfiltered(responseDetailFolder.data);
      }
    }
  }, [responseDetailFolder]);

  // Compute numeric totals for pagination
  const totalDetail =
    detailFolder?.header?.totalRecords ?? allFilesUnfiltered?.length ?? 0;
  const totalSearch =
    responseSearchDocument?.header?.totalRecords ??
    responseSearchDocument?.data?.length ??
    0;

  useEffect(() => {
    try {
      // If input is cleared, ignore late responses from an older request
      if (!valueSearch || valueSearch.trim() === "") {
        setAutoCompleteResults([]);
        return;
      }
      if (responseSearchDocument?.data) {
        setAutoCompleteResults(responseSearchDocument.data.slice(0, 5));
        setLoading7(false);
      } else if (errorSearchDocument) {
        // Handle search error gracefully - clear results and stop loading
        setAutoCompleteResults([]);
        setLoading7(false);
      }
    } catch (error) {
      setLoading7(false);
    }
  }, [responseSearchDocument, errorSearchDocument, valueSearch]);

  useEffect(() => {
    try {
      if (responseRecent?.data) {
        const sortedRecentFiles = responseRecent.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRecentFiles(sortedRecentFiles);
        setLoading7(false);
      } else if (errorRecent || loadingRecent === false) {
        // Handle recent files error or loading complete - clear loading state
        setLoading7(false);
      }
    } catch (error) {
      setLoading7(false);
    }
  }, [responseRecent, errorRecent, loadingRecent]);

  const searchFile = (_filterSearch) => {
    setIsTrash(false);
    setPage(1);
    setResetPager(true);
    if (_filterSearch) {
      bySearch = true;
      filterSearch = _filterSearch;
      let id = mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "";
      let obTerm = {
        filters: [],
        fullTextSearch: { text: _filterSearch, fields: [] },
      };

      dispatch(
        getSearchDocument(
          {
            parentArchiveId: id ? id : "",
            page: 1,
            pageSize: pageSize,
            obTerm,
          },
          navigate
        )
      );
    } else {
      bySearch = false;
      refresh("", page, pageSize);
    }
  };

  const getCanonicalPathFn = (id) => {
    getCanonicalPath(id, (event) => {})
      .then((response) => {
        if (response.data && response.data.length > 0) {
          let listMP = [];
          let responseSorted = response.data.sort((a, b) => {
            if (a.Level > b.Level) {
              return 1;
            }
            if (a.Level < b.Level) {
              return -1;
            }
            return 0;
          });

          responseSorted.map((cp) => {
            if (cp.Type === "Folder") {
              listMP.push({
                name: cp.Name,
                id: cp.Id,
                parent: cp.ParentArchiveId,
              });
            }
          });
          
          if (listMP.length > 0) {
            // Normal case: we have a canonical folder path, navigate there
            clickMap(listMP[listMP.length - 1].id);
            setMapPath(listMP);
            setPage(1);
            setResetPager(true);
          } else {
            // If no folders found, the file might be in root or we need to load its parent folder
            // Let's check if the file has a parent folder
            const fileItem = responseSorted[0];
            if (fileItem && fileItem.ParentArchiveId) {
              // Load the parent folder
              dispatch(
                getDetailFolderList(
                  {
                    parentArchiveId: fileItem.ParentArchiveId,
                    page: 1,
                    pageSize: pageSize,
                  },
                  navigate
                )
              );
              dispatch(
                getTreeList(
                  { parentArchiveId: fileItem.ParentArchiveId, direction: "" },
                  navigate
                )
              );
              setInFolderView(true);
            } else {
              // File is in root, load root explorer
              dispatch(
                getDetailFolderList(
                  {
                    parentArchiveId: "",
                    page: 1,
                    pageSize: pageSize,
                  },
                  navigate
                )
              );
              dispatch(
                getTreeList(
                  { parentArchiveId: "", direction: "" },
                  navigate
                )
              );
              setInFolderView(true); // Keep folder view to show AllFilesDocPlace with highlighting
            }
          }
        } else {
          // If no data, load root explorer
          dispatch(
            getDetailFolderList(
              {
                parentArchiveId: "",
                page: 1,
                pageSize: pageSize,
              },
              navigate
            )
          );
          dispatch(
            getTreeList(
              { parentArchiveId: "", direction: "" },
              navigate
            )
          );
        }
      })
      .catch((err) => {
        console.error("Error in getCanonicalPathFn:", err);

        // If we already have a navigation context (coming from File Manager),
        // keep that instead of forcing the user back to root.
        const storedMapPath =
          mapPath && mapPath.length > 0
            ? mapPath
            : JSON.parse(localStorage.getItem("route-mapPath") || "[]");

        if (storedMapPath && storedMapPath.length > 0) {
          const lastFolderId = storedMapPath[storedMapPath.length - 1].id;

          dispatch(
            getDetailFolderList(
              {
                parentArchiveId: lastFolderId,
                page: 1,
                pageSize: pageSize,
              },
              navigate
            )
          );
          dispatch(
            getTreeList(
              { parentArchiveId: lastFolderId, direction: "" },
              navigate
            )
          );
          setInFolderView(true);
        } else {
          // As a last resort (no context available), fall back to root
          dispatch(
            getDetailFolderList(
              {
                parentArchiveId: "",
                page: 1,
                pageSize: pageSize,
              },
              navigate
            )
          );
          dispatch(
            getTreeList(
              { parentArchiveId: "", direction: "" },
              navigate
            )
          );
        }
      })
      .finally(() => {
        //setLoading(false);
      });
  };

  const showTreeFN = (item) => {
    setShowTree(item);
    setPage(1);
    setResetPager(true);
  };

  useEffect(() => {}, [searchActive]);

  const refresh = (searchQuery = "", page = 1, pageSize = 50) => {
    console.log("REFRESH");
    setValueSearch("");
    // Clear search params from URL

    setFilterList({
      filters: [],
      fullTextSearch: {
        text: "",
        fields: [],
      },
      fromDate: "",
      toDate: "",
      daysAgo: 0,
      minsAgo: 0,
    });

    setIsTrash(false);
    setInFolderView(false);
    setMapPath([]);
    setForwardStack([]);
    setTree({
      label: "",
      value: "",
      parent: "",
    });

    setPage(1);
    setPageSize(pageSize);
    setResetPager(true);

    dispatch(
      getDetailFolderList(
        {
          parentArchiveId: "",
          page: page,
          pageSize: pageSize,
        },
        navigate
      )
    );
    dispatch(
      getTreeList(
        {
          parentArchiveId: "",
          direction: "",
        },
        navigate
      )
    );
  };
  const refreshAction = () => {
    // If we're navigating to a specific file, don't change inFolderView
    if (targetFileId) {
      setPage(page);
      setPageSize(pageSize);
      setResetPager(true);

      dispatch(
        getDetailFolderList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            page: page,
            pageSize: pageSize,
            cacheBust: Date.now(), // Force fresh data fetch after operations
          },
          navigate
        )
      );
      refreshRecentFiles();
      return;
    }

    // Normal refresh behavior when no target file
    setPage(page);
    setPageSize(pageSize);
    setResetPager(true);

    dispatch(
      getDetailFolderList(
        {
          parentArchiveId:
            mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
          page: page,
          pageSize: pageSize,
          cacheBust: Date.now(), // Force fresh data fetch after operations
        },
        navigate
      )
    );
    refreshRecentFiles();
  };
  const refreshSearch = (item, mpage = page, mrows = pageSize) => {
    console.log("refreshSearch", mpage, mrows);
    let _filterSearch = filterSearch;
    let id = mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "";
    let obTerm = {
      filters: [],
      fullTextSearch: { text: _filterSearch, fields: [] },
    };

    dispatch(
      getSearchDocument(
        {
          parentArchiveId: id ? id : "",
          page: mpage,
          pageSize: mrows,
          obTerm,
        },
        navigate
      )
    );
    setPage(mpage);
    setPageSize(mrows);
  };

  const getSearchFile = () => {
    if (valueSearch || filterList.filters.length > 0) {
      let obj = {
        filters: filterList.filters,
        fullTextSearch: {
          text: valueSearch.toLowerCase(),
          fields: [],
        },
        daysAgo: 0,
        minsAgo: 0,
      };

      dispatch(
        getSearchDocument(
          {
            page: 1,
            pageSize: pageSize,
            period: calculatePeriod(daysFilter), // Use 30-day default period
            data: obj,
          },
          navigate
        )
      );
    } else {
      toast.error("Enter a value");
    }
  };
  const addNewFilter = (fl) => {
    const newFilterList = {
      ...filterList,
      fullTextSearch: {
        text: valueSearch,
        fields: [],
      },
      filters: [...filterList.filters, fl], // fl contains both filter + date
      fromDate: fl.fromDate ? fl.fromDate : "2020-01-01",
      toDate: fl.toDate ? fl.toDate : new Date().toISOString().split("T")[0],
    };

    setFilterList(newFilterList);
    setSearchActive(true);

    dispatch(
      getSearchDocument(
        {
          page: 1,
          pageSize: pageSize,
          period: calculatePeriod(daysFilter), // Use 30-day default period
          data: newFilterList,
        },
        navigate
      )
    );
  };

  const removeFilter = (id) => {
    const updatedFilters = [...filterList.filters];
    updatedFilters.splice(id, 1);

    const newFilterList = {
      ...filterList,
      filters: updatedFilters,
    };

    setFilterList(newFilterList);

    if (updatedFilters.length > 0 || valueSearch) {
      dispatch(
        getSearchDocument(
          {
            page: 1,
            pageSize: pageSize,
            period: calculatePeriod(daysFilter), // Use 30-day default period
            data: newFilterList,
          },
          navigate
        )
      );
    } else {
      setSearchActive(false);
      refresh();
    }
  };

  const removeFilterDate = () => {
    setSearchActive(true);
    if (filterListC.filters.length > 0) {
      filterListC.fromDate = "";
      filterListC.toDate = "";
    }

    if (filterList.filters.length > 0) {
      filterList.fromDate = undefined;
      filterList.toDate = undefined;
    }

    dispatch(
      getSearchDocument(
        {
          page: 1,
          pageSize: pageSize,
          period: calculatePeriod(daysFilter), // Use 30-day default period
          data: filterList,
        },
        navigate
      )
    );
  };

  const upLevel = (item) => {
    setIsTrash(false);
    let m = mapPath;
    if (m.length - 1 >= 1) {
      //this.props.fetchDocumentsDetails(m[(m.length - 2)].id,null, 1, pageSize);
      m.splice(m.length - 1, 1);
    } else {
      //this.props.getFolders();
      m = [];
    }
    this.setState({
      mapPath: m,
      page: 1,
    });
    setPage(1);
  };

  const homeTree = (item) => {
    setInFolderView(false);
    setIsTrash(false);
    setForwardStack([]);
    dispatch(
      getDetailFolderList(
        { parentArchiveId: "", page: 1, pageSize: pageSize },
        navigate
      )
    );
    dispatch(getTreeList({ parentArchiveId: "", direction: "UP" }, navigate));
    setMapPath([]);
    setPage(1);

    setResetPager(true);
  };

  const clickMap = (id, _mapPath) => {
    setForwardStack([]);
    let mp = _mapPath ? _mapPath : mapPath;
    setInFolderView(true);
    dispatch(
      getDetailFolderList(
        {
          parentArchiveId: id ? id : "",
          page: 1,
          pageSize: pageSize,
        },
        navigate
      )
    );
    dispatch(
      getTreeList({ parentArchiveId: id ? id : "", direction: "" }, navigate)
    );
    let newMap = [];
    let end = false;
    mp.map((map, idx) => {
      if (map.id != id) {
        if (!end) {
          newMap.push(map);
        }
      } else {
        newMap.push(map);
        end = true;
      }
    });

    setMapPath(newMap);
    setPage(1);
    setResetPager(true);
  };

  const newFolder = (item) => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            page: 1,
            pageSize: pageSize,
            cacheBust: Date.now(), // Force fresh data fetch
          },
          navigate
        )
      );
      dispatch(
        getTreeList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            direction: "",
            cacheBust: Date.now(), // Force fresh data fetch
          },
          navigate
        )
      );
      setPage(1);
      setResetPager(true);
    }, 500); // 500ms delay for cache invalidation propagation
  };

  const clickTree = (item, mp) => {
    setForwardStack([]);
    setCurrentFolderId(item.value);
    setInFolderView(true);
    setPage(1);
    setTree({
      label: item.label,
      value: item.value,
      parent: !tree.label ? "" : item.parent ? item.parent.id : "",
    });
    dispatch(
      getTreeList({ parentArchiveId: item.value, direction: "" }, navigate)
    );
    dispatch(
      getDetailFolderList(
        { parentArchiveId: item.value, page: 1, pageSize: 50 },

        navigate
      )
    );

    let m = mp ? mp : mapPath;
    m.push({
      name: item.label,
      id: item.value,
      parent: !tree.label ? "" : item.parent ? item.parent.id : "",
    });
    setMapPath(m);
    setPage(1);
    setResetPager(true);
  };

  const [viewMode, setViewMode] = useState("grid");

  const backTree = (item) => {
    setIsTrash(false);
    if (mapPath.length > 1) {
      setForwardStack((prev) => [...prev, [...mapPath]]);
      const newMapPath = [...mapPath];
      newMapPath.pop();
      const lastItem = newMapPath[newMapPath.length - 1];

      setMapPath(newMapPath);
      setPage(1);
      setResetPager(true);

      dispatch(
        getDetailFolderList(
          {
            parentArchiveId: lastItem.id,
            page: 1,
            pageSize: pageSize,
          },
          navigate
        )
      );
      dispatch(
        getTreeList(
          {
            parentArchiveId: lastItem.id,
            direction: "",
          },
          navigate
        )
      );
    } else {
      homeTree();
    }
  };

  const forwardTree = () => {
    if (forwardStack.length === 0) return;
    const nextMapPath = forwardStack[forwardStack.length - 1];
    setForwardStack((prev) => prev.slice(0, -1));
    const lastItem = nextMapPath[nextMapPath.length - 1];

    setMapPath(nextMapPath);
    setInFolderView(true);
    setPage(1);
    setResetPager(true);

    dispatch(
      getDetailFolderList(
        {
          parentArchiveId: lastItem.id,
          page: 1,
          pageSize: pageSize,
        },
        navigate
      )
    );
    dispatch(
      getTreeList(
        {
          parentArchiveId: lastItem.id,
          direction: "",
        },
        navigate
      )
    );
  };

  const clickFile = (item) => {
    let exist = false;
    mapPath.map((map, idx) => {
      if (
        (item.folder && map.name === item.name) ||
        (!item.folder && map.name === item.archive.name)
      ) {
        exist = true;
      }
    });

    if (!exist) {
      let m = mapPath;
      m.push({
        name: item.folder ? item.name : item.archive.name,
        id: item.folder ? item.id : item.archive.id,
      });
      setMapPath(m);
    }
  };

  const addComment = (item) => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      refreshAction();
    }, 500);
  };

  const updateFile = (files) => {
    if (isReadOnlyCached()) {
      notify("This workspace is read-only — upload in the new DocPlace platform.", "info");
      return;
    }
    handleScrollContainerToTop();
    window.scrollTo(0, 0);
    setCloseUploadFiles(false);
    setTotalFiles(files);
    if (files && files.length > 0) {
      setShowUploadUI(true);
    }
    setUploadStatusByKey((prev) => {
      const next = { ...prev };
      (files || []).forEach((f) => {
        const key = `${f.name}-${f.size}-${f.lastModified || 0}`;
        if (!next[key]) {
          next[key] = { progress: 0, status: "pending", error: null };
        }
      });
      return next;
    });
  };

  const finishUploadSession = () => {
    setCloseUploadFiles(true);
    setTotalFiles([]);
    setShowUploadUI(false);
    refreshAction();
    setUpDocType({});
    setOpenModal(false);
    setDocumentName("");
    setFilesToUpload([]);
    pendingDuplicateFilesRef.current = [];
  };

  const advanceAfterDuplicateResolution = () => {
    const next = pendingDuplicateFilesRef.current.shift();
    if (next) {
      setFilesToUpload([next]);
      setDocumentName(next.name);
      setOpenModal(true);
    } else {
      finishUploadSession();
    }
  };

  const uploadFilesWithConcurrencyPool = async (filesPendingUpload, actionSelected) => {
    // Read-only (migrated) workspace: block every upload path (toolbar, drag-drop, folder-browse).
    if (isReadOnlyCached()) {
      notify("This workspace is read-only — upload in the new DocPlace platform.", "info");
      return [];
    }
    if (!filesPendingUpload || filesPendingUpload.length === 0) {
      return [];
    }

    const uploadOne = async (file) => {
      const key = `${file.name}-${file.size}-${file.lastModified || 0}`;
      setUploadStatusByKey((prev) => ({
        ...prev,
        [key]: {
          ...(prev[key] || {}),
          status: "uploading",
          progress: 0,
          error: null,
        },
      }));
      try {
        await uploadFileManual(
          file,
          (evt) => {
            const total = evt?.total || 0;
            const loaded = evt?.loaded || 0;
            const pct = total > 0 ? Math.round((loaded / total) * 100) : 0;
            setUploadStatusByKey((prev) => ({
              ...prev,
              [key]: {
                ...(prev[key] || {}),
                status: "uploading",
                progress: pct,
                error: null,
              },
            }));
          },
          upDocType.value ? upDocType.value.value : null,
          mapPath.length - 1 < 0 ? null : mapPath[mapPath.length - 1].id,
          false,
          actionSelected
        );

        notify(`${file.name} uploaded`, "success");
        setUploadStatusByKey((prev) => ({
          ...prev,
          [key]: {
            ...(prev[key] || {}),
            status: "done",
            progress: 100,
            error: null,
          },
        }));
        return { file, success: true };
      } catch (err) {
        const errorMessage =
          err?.response?.data?.error?.messages?.[0]?.message ||
          "Error uploading file";
        toast.error(errorMessage);
        setUploadStatusByKey((prev) => ({
          ...prev,
          [key]: {
            ...(prev[key] || {}),
            status: "error",
            error: errorMessage,
          },
        }));
        return { file, success: false };
      }
    };

    const results = new Array(filesPendingUpload.length);
    let nextIndex = 0;
    const workerCount = Math.min(UPLOAD_CONCURRENCY, filesPendingUpload.length);

    const worker = async () => {
      while (true) {
        const i = nextIndex++;
        if (i >= filesPendingUpload.length) {
          break;
        }
        results[i] = await uploadOne(filesPendingUpload[i]);
      }
    };

    await Promise.all(Array.from({ length: workerCount }, () => worker()));
    return results;
  };

  const moveFile = () => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      refreshAction();
    }, 500);
  };

  const reprocessFile = (v) => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      refreshAction();
    }, 500);
  };

  const deleteFile = (item) => {
    let id = [];
    //setPage(1); setResetPager(true);
    id.push(item.item.folder ? item.item.id : item.item.fkArchive.id);
    dispatch(postDeleteDoc(id, navigate));
  };

  useEffect(() => {
    const { fromDate, toDate } = calculateDateRange(daysFilter);
    dispatch(
      getRecent(
        {
          page: 1,
          pageSize: 25, // limit results for recent files
          period: calculatePeriod(daysFilter), // Set period based on daysFilter (default: 30d)
          data: {
            filters: [],
            fullTextSearch: {
              text: ".",
              fields: [],
            },
            daysAgo: 0,
            minsAgo: 0,
            fromDate, // Last N days
            toDate, // Today
          },
        },
        navigate
      )
    );
  }, [daysFilter]);

  const shareFile = (item) => {
    // this.props.shareDocument(item.item.id, item.shareFiles);
  };

  const renameFile = () => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            page: 1,
            pageSize: pageSize,
            cacheBust: Date.now(), // Force fresh data fetch
          },
          navigate
        )
      );
      dispatch(
        getTreeList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            direction: "",
            cacheBust: Date.now(), // Force fresh data fetch
          },
          navigate
        )
      );
      setPage(1);
      setResetPager(true);
      refreshRecentFiles();
    }, 500); // 500ms delay for cache invalidation propagation
  };
  const recoverFile = () => {
    // Add delay to allow cache invalidation to propagate before refresh
    setTimeout(() => {
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId:
              mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            page: 1,
            pageSize: pageSize,
            cacheBust: Date.now(), // Force fresh data fetch
          },
          navigate
        )
      );
      setPage(1);
      setResetPager(true);
      refreshRecentFiles();
    }, 500); // 500ms delay for cache invalidation propagation
  };
  const openFolder = (item) => {
    setPage(1);
    setResetPager(true);
    // this.props.fetchDocumentsDetails(item.folder ? item.id : item.archive.id, null, page, pageSize);
  };

  const openFile = (item) => {
    setPage(1);
    setResetPager(true);

    localStorage.setItem("route-item", JSON.stringify(item));
    localStorage.setItem("route-mapPath", JSON.stringify(mapPath));
    
    // Store search query if search is active, so we can restore it when navigating back
    if (searchActive && searchCurrentQuery) {
      localStorage.setItem("searchQuery", searchCurrentQuery);
    } else {
      // Clear any previously stored search query if not in search mode
      localStorage.removeItem("searchQuery");
    }
    
    navigate("/docViewer/" + item.id);
  };

  const nextPageFN = (pages, rows) => {
    console.log("nextPageFN", pages, rows);
    setPage(pages);
    setPageSize(rows);
    setNextPage(true);

    if (bySearch == true) {
      refreshSearch("", pages + 1, rows);
    } else {
      updateNavigation(pages + 1, rows);
    }
  };

  const updateNavigation = (pages, rows) => {
    if (mapPath.length > 0) {
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId: mapPath[mapPath.length - 1].id,
            page: pages,
            pageSize: rows,
          },
          navigate
        )
      );
      dispatch(
        getTreeList(
          {
            parentArchiveId: mapPath[mapPath.length - 1].id,
            page: pages,
            pageSize: rows,
          },
          navigate
        )
      );
    } else {
      dispatch(
        getDetailFolderList(
          {
            parentArchiveId: "",
            page: pages,
            pageSize: rows,
          },
          navigate
        )
      );
      dispatch(
        getTreeList(
          {
            parentArchiveId: "",
            page: pages,
            pageSize: rows,
          },
          navigate
        )
      );
    }
  };

  const closeUpload = () => {
    setCloseUploadFiles(true);
    setTotalFiles([]);
    setShowUploadUI(false);
    pendingDuplicateFilesRef.current = [];
  };

  const openUploadPicker = () => {
    uploadInputRef.current?.click?.();
  };

  const openUploadModal = () => {
    setCloseUploadFiles(false);
    setShowUploadUI(true);
  };

  const onUploadInputChange = (e) => {
    const selected = Array.from(e?.target?.files || []);
    e.target.value = "";
    if (!selected.length) return;
    const merged = [...(totalFiles || []), ...selected];
    const uniqMap = new Map();
    merged.forEach((f) => {
      const key = `${f.name}-${f.size}-${f.lastModified || 0}`;
      if (!uniqMap.has(key)) uniqMap.set(key, f);
    });
    updateFile(Array.from(uniqMap.values()));
  };

  const saveUpload = async () => {
    if (!totalFiles?.length) return;

    const validateFilePromises = totalFiles.map((file) => {
      setDocumentName(file.name);
      return validateFiles(
        mapPath.length - 1 < 0 ? null : mapPath[mapPath.length - 1].id,
        file.name
      )
        .then((response) => {
          if (response?.data.length === 0) {
            return { file, readyToUpload: true };
          }
          return { file, readyToUpload: false, conflict: true };
        })
        .catch((err) => {
          console.log("ERROR", err);
          return { file, readyToUpload: false, conflict: false };
        });
    });

    const results = await Promise.all(validateFilePromises);
    const filesReadyToUpload = results
      .filter((r) => r.readyToUpload)
      .map((r) => r.file);
    const conflictFiles = results.filter((r) => r.conflict).map((r) => r.file);

    pendingDuplicateFilesRef.current = conflictFiles.slice(1);

    let anyUploaded = false;

    if (filesReadyToUpload.length > 0) {
      setUploaded(true);
      setMessageText(
        filesReadyToUpload.length > 1
          ? `Uploading ${filesReadyToUpload.length} files…`
          : "Uploading document"
      );
      const uploadResults = await uploadFilesWithConcurrencyPool(
        filesReadyToUpload,
        ""
      );
      anyUploaded = uploadResults.some((r) => r?.success);
      setUploaded(false);
      setMessageText("Getting Explorer Data");
      if (anyUploaded && conflictFiles.length > 0) {
        refreshAction();
      }
    }

    if (conflictFiles.length > 0) {
      setFilesToUpload([conflictFiles[0]]);
      setDocumentName(conflictFiles[0].name);
      setOpenModal(true);
      return;
    }

    if (anyUploaded) {
      finishUploadSession();
    }
  };

  const onClickReplace = async () => {
    if (filesToUpload.length === 0) return;
    setOpenModal(false);
    setUploaded(true);
    setMessageText("Uploading document");
    await uploadFilesWithConcurrencyPool(filesToUpload, "replace");
    setUploaded(false);
    setMessageText("Getting Explorer Data");
    advanceAfterDuplicateResolution();
  };

  const onClickKeepBoth = async () => {
    if (filesToUpload.length === 0) return;
    setOpenModal(false);
    setUploaded(true);
    setMessageText("Uploading document");
    await uploadFilesWithConcurrencyPool(filesToUpload, "");
    setUploaded(false);
    setMessageText("Getting Explorer Data");
    advanceAfterDuplicateResolution();
  };

  const clickItem = (item, event) => {
    if (event.ctrlKey || event.metaKey) {
      if (!selectedFiles.includes(item.fkArchive.id)) {
        setSelectedFiles((selectedFiles) => [
          ...selectedFiles,
          item.fkArchive.id,
        ]);
      } else {
        setSelectedFiles(
          selectedFiles.filter((id) => id !== item.fkArchive.id)
        );
      }
    } else {
      setSelectedFiles([]);
      setItem(item);
    }
  };

  const openMenuItem = () => {};
  const setTrash = (opt) => {
    console.log("SET MODE", opt);
    setIsTrash(opt);
  };

  /**DOC-1441 confirm dialog for the trash bin */
  const emptyTrashBin = () => {
    Swal.fire({
      title:
        "Are you sure you want to permanently erase the items in the Trash? You can't undo this action",
      showCancelButton: true,
      confirmButtonText: "Empty",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(postEmptyTrashBin(navigate));
      }
    });
  };
  const resetDone = () => {
    setResetPager(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>File Manager</title>
        </MetaTags>
        <Container className="parent-container">
          <ReadOnlyBanner />
          <Title title={"File Manager"} viewActive={false} />
          <ToastContainer autoClose={3000} />

          <LoadingComponent
            show={
              loading ||
              loading2 ||
              loading3 ||
              loading4 ||
              loading5 ||
              loading6 ||
              loading7 ||
              loading8 ||
              loadingEmptyTrash ||
              uploaded === true
            }
            text={messageText}
          />

          <NavDocPlace
              showTree={showTreeFN}
              refresh={refreshAction}
              upLevel={upLevel}
              clickHomeMap={homeTree}
              clickMap={clickMap}
              callBackOptionMenuItemsOpen={openMenuItem}
              selectedFiles={selectedFiles}
              mapPath={mapPath}
              toggleRecent={showRecentFiles}
              showRecent={showRecent}
              canGoBack={mapPath.length > 0}
              canGoForward={forwardStack.length > 0}
              backTree={backTree}
              forwardTree={forwardTree}
              docTypeList={doctypes}
              clearTrash={emptyTrashBin}
              onUploadClick={saveUpload}
              callSearch={(filter) => searchFile(filter)}
              clear={refresh}
              onUploadPrimaryClick={openUploadModal}
              uploadF={updateFile}
              closeUp={closeUploadFiles}
              toggleGridView={() => showViewMode("grid")}
              toggleListView={() => showViewMode("list")}
              viewMode={viewMode}
              searchQuery={valueSearch}
              newFolder={newFolder}
              //search params
              setSearchQuery={(e) => {
                setValueSearch(e);
              }}
              handleSearchClick={handleSearchClick}
              handleFilterClick={() => setShowFilter(true)}
              resetSearch={resetSearch}
              autoCompleteResults={autoCompleteResults}
              autoCompleteLoading={loadingSearchDocument}
              handleSelectFile={handleSelectFile}
              handleViewAll={handleViewAll}
              searchActive={searchActive}
              setSearchActive={setSearchActive}
              show={showFilter}
              close={() => setShowFilter(false)}
              done={(filter) => addNewFilter(filter)}
              doctypeText={() => {}}
              targetFileId={targetFileId}
            />

          <input
            ref={uploadInputRef}
            type="file"
            multiple
            style={{ display: "none" }}
            onChange={onUploadInputChange}
          />

          <Dialog
            open={showUploadUI}
            onClose={closeUpload}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle sx={{ fontWeight: 700 }}>Upload files</DialogTitle>
            <DialogContent dividers>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Dropzone
                  multiple
                  onDrop={(dropped) => {
                    if (!dropped?.length) return;
                    const merged = [...(totalFiles || []), ...dropped];
                    const uniqMap = new Map();
                    merged.forEach((f) => {
                      const key = `${f.name}-${f.size}-${f.lastModified || 0}`;
                      if (!uniqMap.has(key)) uniqMap.set(key, f);
                    });
                    updateFile(Array.from(uniqMap.values()));
                  }}
                >
                  {({ getRootProps, getInputProps, isDragActive }) => (
                    <Box
                      {...getRootProps()}
                      sx={{
                        border: "1px dashed rgba(0,0,0,0.25)",
                        borderRadius: 2,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        bgcolor: isDragActive ? "rgba(0,118,255,0.06)" : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontWeight: 700 }}>
                          Drag & drop files here
                        </Typography>
                        <Typography sx={{ color: "text.secondary", fontSize: 13 }}>
                          Or browse to select multiple files. Uploads run a few at a time
                          so the server is not overloaded.
                        </Typography>
                      </Box>
                      <Button
                        variant="outlined"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          openUploadPicker();
                        }}
                      >
                        Browse files
                      </Button>
                    </Box>
                  )}
                </Dropzone>

                <Box>
                  <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                    Document Type (optional)
                  </Typography>
                  <SelectDropdown
                    id={"period"}
                    field={upDocType}
                    arrayList={listUpDocType}
                    setField={setUpDocType}
                    label=""
                  />
                  <Typography sx={{ color: "text.secondary", mt: 0.75, fontSize: 13 }}>
                    If you select a DocType, DocPlace can index the upload and extract attributes.
                    If you don’t, documents upload without an index.
                  </Typography>
                </Box>

                <Box>
                  <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                    Files selected
                  </Typography>
                  {totalFiles?.length ? (
                    <List dense sx={{ maxHeight: 240, overflow: "auto", bgcolor: "background.paper", borderRadius: 1, border: "1px solid rgba(0,0,0,0.08)" }}>
                      {totalFiles.slice(0, 50).map((f, idx) => (
                        <ListItem
                          key={`${f.name}-${f.size}-${f.lastModified || 0}-${idx}`}
                          sx={{ py: 0.25, alignItems: "flex-start" }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <ListItemText
                                primary={f.name}
                                secondary={`${(f.size / 1000000).toFixed(2)} MB`}
                              />
                              {(() => {
                                const key = `${f.name}-${f.size}-${f.lastModified || 0}`;
                                const st = uploadStatusByKey[key];
                                if (!st) return null;
                                if (st.status === "uploading") {
                                  return (
                                    <Box sx={{ mt: 0.5 }}>
                                      <LinearProgress
                                        variant="determinate"
                                        value={st.progress || 0}
                                      />
                                      <Typography
                                        sx={{
                                          fontSize: 12,
                                          color: "text.secondary",
                                          mt: 0.25,
                                        }}
                                      >
                                        Uploading… {st.progress || 0}%
                                      </Typography>
                                    </Box>
                                  );
                                }
                                if (st.status === "done") {
                                  return (
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: "success.main",
                                        mt: 0.25,
                                      }}
                                    >
                                      Done
                                    </Typography>
                                  );
                                }
                                if (st.status === "error") {
                                  return (
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: "error.main",
                                        mt: 0.25,
                                      }}
                                    >
                                      Failed: {st.error || "Upload failed"}
                                    </Typography>
                                  );
                                }
                                return null;
                              })()}
                            </Box>
                            {(() => {
                              const key = `${f.name}-${f.size}-${f.lastModified || 0}`;
                              const st = uploadStatusByKey[key];
                              if (st?.status === "done") {
                                return (
                                  <CheckCircleOutlineIcon
                                    sx={{ color: "success.main" }}
                                  />
                                );
                              }
                              if (st?.status === "error") {
                                return (
                                  <ErrorOutlineIcon sx={{ color: "error.main" }} />
                                );
                              }
                              if (st?.status === "uploading") {
                                return <CircularProgress size={18} />;
                              }
                              return null;
                            })()}
                          </Box>
                        </ListItem>
                      ))}
                      {totalFiles.length > 50 ? (
                        <ListItem>
                          <ListItemText
                            primary={`+ ${totalFiles.length - 50} more file(s)`}
                          />
                        </ListItem>
                      ) : null}
                    </List>
                  ) : (
                    <Typography sx={{ color: "text.secondary" }}>
                      No files selected yet. Drag files in above or click Browse.
                    </Typography>
                  )}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, justifyContent: "space-between" }}>
              <Box />
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="outlined" onClick={closeUpload}>
                  Cancel
                </Button>
                <Button
                  onClick={saveUpload}
                  variant="contained"
                  color="success"
                  startIcon={<UploadIcon />}
                  disabled={!totalFiles?.length}
                >
                  Upload files
                </Button>
              </Box>
            </DialogActions>
          </Dialog>

          <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Grid container direction="row" alignItems="start" spacing={2}>
                <Grid item xs={2}>
                  <img
                    alt={"document"}
                    src={documentIcon}
                    style={{
                      width: "50px",
                      height: "50px",
                    }}
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    A file with this name already exists, so we couldn't upload{" "}
                    <strong>{documentName}</strong>. Add it as a new version of
                    the existing file or keep them both.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Button
                      onClick={onClickReplace}
                      className={classes.ButtonModal}
                      variant="outlined"
                    >
                      Replace
                    </Button>
                    <Button
                      onClick={onClickKeepBoth}
                      className={classes.ButtonModal}
                      variant="outlined"
                    >
                      Keep both
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Modal>
          {searchActive && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  margin: "12px 0",
                }}
              >
                <div>
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: 400,
                      marginBottom: "6px",
                      color: "#0076FF",
                    }}
                  >
                    Filters Applied
                  </Typography>

                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {filterList.filters.map((f, idx) => (
                      <React.Fragment key={idx}>
                        {f?.filter?.criteria?.map((ct, i) => (
                          <Chip
                            key={`${idx}-${i}`}
                            label={`${ct.field} ${ct.operator} ${ct.value}`}
                            onDelete={() => removeFilter(idx)}
                            color="primary"
                          />
                        ))}

                        {f?.filter?.docTypeName && (
                          <Chip
                            label={`Doctype: ${f.filter.docTypeName}`}
                            onDelete={() => removeFilter(idx)}
                            color="primary"
                          />
                        )}

                        {f?.fromDate && f?.toDate && (
                          <Chip
                            label={`Date: ${f.fromDate} → ${f.toDate}`}
                            onDelete={() => removeFilter(idx)}
                            color="primary"
                          />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                <div>
                  <Button
                    onClick={() => {
                      setFilterList({
                        filters: [],
                        fullTextSearch: { text: "", fields: [] },
                        fromDate: "",
                        toDate: "",
                        daysAgo: 0,
                        minsAgo: 0,
                      });
                      setValueSearch("");
                      setSearchParams({}); // Clear search params from URL
                      setSearchActive(false);
                      refresh();
                    }}
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      textTransform: "none",
                      marginTop: "8px",
                    }}
                  >
                    Reset Filters
                  </Button>
                </div>
              </div>
            </>
          )}

          {searchActive ? (
            <Container fluid style={{ marginTop: "12px" }}>
              <AllFilesDocPlace
                clickTree={clickTree}
                backTree={backTree}
                onBreadcrumbHome={homeTree}
                clickFile={clickFile}
                addComment={addComment}
                mapPath={mapPath}
                updateFile={updateFile}
                moveFile={moveFile}
                reprocessFile={reprocessFile}
                recoverFile={recoverFile}
                deleteFile={deleteFile}
                shareFile={shareFile}
                renameFile={renameFile}
                openFolder={openFolder}
                openFile={openFile}
                nextPage={nextPageFN}
                clickItem={clickItem}
                clickMap={clickMap}
                closeUp={closeUploadFiles}
                page={page}
                pageSize={pageSize}
                reset={resetPager}
                showTree={showTree}
                resetDone={resetDone}
                users={users}
                treePrevius={mapPath || []}
                tree={responseTree || []}
                docTypes={responseDocType1}
                treeActive={tree}
                file={responseSearchDocument?.data || []}
                total={totalSearch}
                isTrash={isTrash}
                setTrash={setTrash}
                viewMode={viewMode}
                showAllFiles={true}
                toggleShowAllFiles={() => {}}
                daysFilter={daysFilter}
                setDaysFilter={setDaysFilter}
                searchQuery={valueSearch}
                searchActive={searchActive}
                loadingSearch={loadingSearchDocument}
                isSearchResults={true}
              />
            </Container>
          ) : (
            <>
              {!inFolderView && showRecent && (
                <FileDocPlace
                  clickTree={clickTree}
                  backTree={backTree}
                  clickFile={clickFile}
                  addComment={addComment}
                  updateFile={updateFile}
                  moveFile={moveFile}
                  reprocessFile={reprocessFile}
                  recoverFile={recoverFile}
                  deleteFile={deleteFile}
                  mapPath={mapPath}
                  shareFile={shareFile}
                  renameFile={renameFile}
                  openFolder={openFolder}
                  openFile={openFile}
                  nextPage={nextPageFN}
                  clickItem={clickItem}
                  closeUp={closeUploadFiles}
                  page={page}
                  reset={resetPager}
                  showTree={showTree}
                  resetDone={resetDone}
                  users={users}
                  treePrevius={mapPath || []}
                  tree={responseTree || []}
                  docTypes={responseDocType1}
                  treeActive={tree}
                  file={recentFiles}
                  total={detailFolder?.header || 0}
                  isTrash={isTrash}
                  setTrash={setTrash}
                  viewMode={viewMode}
                  showAllFiles={recentFiles}
                  toggleShowAllFiles={() =>
                    setShowAllFilesFromRecent((prev) => !prev)
                  }
                  daysFilter={daysFilter}
                  setDaysFilter={setDaysFilter}
                  loadingRecent={loadingRecent}
                  errorRecent={errorRecent}
                  hasReceivedResponse={!!responseRecent}
                />
              )}

              {!showAllFilesFromRecent && (
                <Container fluid style={{ marginTop: "12px" }}>
              <AllFilesDocPlace
                clickTree={clickTree}
                backTree={backTree}
                onBreadcrumbHome={homeTree}
                clickFile={clickFile}
                addComment={addComment}
                clickMap={clickMap}
                mapPath={mapPath}
                    updateFile={updateFile}
                    moveFile={moveFile}
                    reprocessFile={reprocessFile}
                    recoverFile={recoverFile}
                    deleteFile={deleteFile}
                    shareFile={shareFile}
                    renameFile={renameFile}
                    openFolder={openFolder}
                    openFile={openFile}
                    nextPage={nextPageFN}
                    clickItem={clickItem}
                    closeUp={closeUploadFiles}
                    page={page}
                    rowsPerPage={pageSize}
                    reset={resetPager}
                    showTree={showTree}
                    resetDone={resetDone}
                    users={users}
                    treePrevius={mapPath || []}
                    tree={responseTree || []}
                    docTypes={responseDocType1}
                    treeActive={tree}
                    file={allFilesUnfiltered}
                    total={totalDetail}
                    isTrash={isTrash}
                    setTrash={setTrash}
                    viewMode={viewMode}
                    showAllFiles={showAllFilesFromRecent}
                    toggleShowAllFiles={() =>
                      setShowAllFilesFromRecent((prev) => !prev)
                    }
                    daysFilter={daysFilter}
                    setDaysFilter={setDaysFilter}
                    limit={limit}
                    targetFileId={targetFileId}
                  />
                </Container>
              )}
            </>
          )}

          <NewFilterDocPlace
            show={showFilter}
            close={() => setShowFilter(false)}
            done={(filter) => addNewFilter(filter)}
            doctypeText={() => {}}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ExplorerDocPlace;
